module.exports = __webpack_public_path__ + "img/20191116143826360截图20191116142849829.ed6efc25.jpg";